"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = void 0;
const data_access_1 = require("@resclick/data-access");
exports.i18n = {
    translate: {
        dto: data_access_1.TranslateDto,
        method: 'post',
        path: '/i18n/translate',
        response: {},
    },
};
//# sourceMappingURL=i18n.api.js.map